/* ============================================================
   Dicionário de traduções — PT / EN
   Estrutura: chaves planas, agrupadas por secção/página por convenção.
   Usar com o hook useT(): const t = useT(); t('home.hero.title')
   ============================================================ */

const dict = {
  pt: {
    /* ── Tipos de vinho (partilhado) ── */
    'wine.type.tintoColheita':  'Tinto Colheita',
    'wine.type.brancoColheita': 'Branco Colheita',
    'wine.type.tintoReserva':   'Tinto Reserva',
    'wine.type.brancoReserva':  'Branco Reserva',

    /* ── Badges ── */
    'badge.destaque': 'Destaque',
    'badge.limitado': 'Limitado',
    'badge.novidade': 'Novidade',

    /* ── Navbar ── */
    'nav.home':       'Home',
    'nav.vinhos':     'Vinhos',
    'nav.loja':       'Loja',
    'nav.vinhas':     'Vinhas',
    'nav.sobre':      'Sobre',
    'nav.contacto':   'Contacto',
    'nav.cart.aria':  'Carrinho com {n} {n_word}',
    'nav.cart.itemSingular': 'artigo',
    'nav.cart.itemPlural':   'artigos',
    'nav.menuOpen':   'Abrir menu',
    'nav.menuClose':  'Fechar menu',
    'nav.cartLabel':  'Carrinho',

    /* ── Footer ── */
    'footer.nav':              'Navegar',
    'footer.contact':          'Contacto',
    'footer.follow':           'Siga-nos',
    'footer.shop':             'Loja',
    'footer.shop.cta':         'Comprar',
    'footer.copyright':        'Todos os direitos reservados',

    'footer.tagline':          'DOC DOURO\nDOURO SUPERIOR',
    'footer.brandLine':        'Casa Agrícola Meneses',
    'footer.address':          'Rua Vasco da Gama 43\n5160-297 Torre de Moncorvo',

    'footer.newsletter.title':       'Newsletter',
    'footer.newsletter.lead':        'Receba lançamentos, novidades e convites para visitas à quinta.',
    'footer.newsletter.placeholder': 'O seu email',
    'footer.newsletter.cta':         'Subscrever',
    'footer.newsletter.success':     'Obrigado! Subscrição confirmada.',
    'footer.newsletter.invalid':     'Indique um email válido.',

    'footer.legal.privacy':    'Política de Privacidade',
    'footer.legal.terms':      'Termos & Condições',
    'footer.legal.cookies':    'Cookies',

    'footer.social.facebook':  'Facebook',
    'footer.social.instagram': 'Instagram',

    /* ── Home ── */
    'home.hero.eyebrow':   'Vale da Vilariça · Douro Superior',
    /* Arco narrativo: terra → sonho → continuação → vinho */
    'home.hero.title':         'Onde as montanhas abraçam o horizonte',
    'home.hero.title.familia': 'O sonho de um Pai',
    'home.hero.title.quinta':  'A vontade de dois filhos',
    'home.hero.title.vinho':   'Cada gota carrega o Douro e a alma da família',
    'home.hero.photoPlaceholder': 'Foto vertical',
    'home.hero.cta1':      'Comprar',
    'home.hero.cta2':      'A nossa história',

    'home.stats.since':       'Origem',
    'home.stats.hectares':    'Vale',
    'home.stats.wines':       'Sub-região',
    'home.stats.sinceValue':  '2023',
    'home.stats.hectaresValue': 'Vilariça',
    'home.stats.winesValue':  'Douro Superior',

    'home.featured.eyebrow': 'Selecção',
    'home.featured.title':   'Vinhos em destaque',
    'home.featured.lead':    'Uma curadoria dos nossos melhores néctares, prontos a descobrir.',
    'home.featured.cta':     'Ver toda a colecção',

    'home.about.eyebrow': 'Sobre nós',
    'home.about.title':   'Tradição e excelência em cada garrafa',
    'home.about.lead':    'Nascido da vontade de dois irmãos, impulsionados pelo sonho do seu Pai, Douro Nostrum é mais do que um vinho, é uma celebração e uma homenagem ao trabalho árduo dos seus antepassados na região e uma manifestação do orgulho pelas origens, que rege toda a existência.',
    'home.about.cta':     'Saber mais',

    /* ── Age gate ── */
    'age.title':   'Bem vindo',
    'age.brand':   'Douro Nostrum',
    'age.lead':    'Para entrar, confirme que tem idade legal para o consumo de bebidas alcoólicas.',
    'age.confirm': 'Tenho mais de 18 anos',
    'age.deny':    'Sou menor de 18',
    'age.denied':  'Lamentamos, mas o acesso a este site é restrito a maiores de 18 anos.',

    'home.cta.eyebrow':   'Contacto',
    'home.cta.title':     'Tem alguma questão?',
    'home.cta.lead':      'Estamos sempre disponíveis para responder às suas questões ou simplesmente para falar sobre vinho.',
    'home.cta.button':    'Falar connosco',

    /* ── Páginas Douro Superior / Vale Vilariça / Origem ── */
    'territorio.douroSup.eyebrow':  'Sub-região',
    'territorio.douroSup.title':    'Douro Superior',
    'territorio.douroSup.short':    'No Douro Superior, a força da natureza encontra a nobreza do tempo. Entre paisagens imponentes, clima extremo e solos de carácter singular, nasce uma expressão vínica intensa, elegante e profundamente autêntica.\n\nÉ uma terra de resiliência e excelência, onde cada vinha traduz a alma do Douro em vinhos de identidade marcante, sofisticação natural e rara profundidade.',
    'territorio.douroSup.long':     'O Douro Superior representa a expressão mais intensa, autêntica e majestosa da Região Demarcada do Douro. Situada no extremo oriental desta histórica região vinícola, esta sub-região distingue-se por uma paisagem de grande imponência, por condições naturais excecionais e por uma identidade vínica de rara profundidade.\n\nMarcado por um clima quente, seco e exigente, com verões de grande intensidade e escassa precipitação, o Douro Superior desafia a vinha a superar-se em cada ciclo. Desta relação entre rigor natural e resiliência nasce uma matéria-prima de excelência: uvas de extraordinária concentração, riqueza aromática e notável equilíbrio. Os solos predominantemente xistosos, aliados à força da luz, à amplitude térmica e à singularidade do território, conferem aos vinhos uma estrutura distinta, uma elegância natural e uma impressionante capacidade de evolução em garrafa.\n\nÉ nesta paisagem única que se originam vinhos de elevada assinatura, onde a intensidade se harmoniza com a sofisticação. Os tintos revelam profundidade, textura e complexidade, com notas de fruta negra madura, especiarias e uma notável presença em prova. Os brancos, produzidos sobretudo em cotas mais elevadas, surpreendem pela sua frescura, precisão e mineralidade. Também os Vinhos do Porto encontram no Douro Superior uma expressão de grande nobreza, marcada pela concentração, pela riqueza e pela longevidade.\n\nMais do que uma sub-região, o Douro Superior é hoje um símbolo de excelência, visão e autenticidade. Um território onde tradição e inovação coexistem em perfeita harmonia, dando origem a vinhos de carácter singular, capazes de traduzir com distinção a grandeza do Douro e o prestígio da viticultura portuguesa.',

    'territorio.vilarica.eyebrow':  'Vinhas',
    'territorio.vilarica.title':    'Vale da Vilariça',
    'territorio.vilarica.short':    'No coração do nordeste de Portugal, o Vale da Vilariça revela-se como um território de rara generosidade e beleza intemporal. Moldado por solos férteis, pela luz intensa do Douro Superior e por uma profunda ligação à terra, este vale dá origem a produtos de excelência, onde autenticidade, elegância e carácter se unem de forma singular.\n\nEntre a tradição agrícola, a riqueza da paisagem e a nobreza de um terroir único, o Vale da Vilariça afirma-se como um símbolo de identidade, sofisticação e excelência natural.',
    'territorio.vilarica.long':     'O Vale da Vilariça é um dos territórios agrícolas mais notáveis do nordeste de Portugal, distinguindo-se pela fertilidade dos seus solos, pela riqueza da sua paisagem e pela autenticidade que imprime a tudo o que ali nasce. Situado no concelho de Torre de Moncorvo, entre as serras do Reboredo e da Lousa, este vale beneficia de condições naturais de excelência, que o tornam particularmente vocacionado para a produção agrícola de elevada qualidade.\n\nMarcado por um clima mediterrânico, com verões quentes e luminosos e invernos agrestes, o vale reúne características únicas para o desenvolvimento de culturas de grande valor. Vinhos, azeites, amêndoas e fruta encontram aqui um terroir privilegiado, onde a generosidade da terra se alia à tradição e ao saber de várias gerações.\n\nInserido na área de influência do Douro Superior e em estreita ligação com a histórica Região Demarcada do Douro, o Vale da Vilariça partilha a nobreza de um dos mais prestigiados territórios vínicos do mundo. Nesta região de identidade forte, os solos, o clima e a paisagem moldam produtos de carácter singular, onde se destacam vinhos de grande expressão, elegância e autenticidade.\n\nMais do que um vale fértil, a Vilariça é um território de excelência, onde natureza, história e vocação agrícola convivem em perfeita harmonia. A sua beleza serena, a riqueza patrimonial e a qualidade excecional da sua produção fazem deste lugar uma referência incontornável para quem procura genuinidade e ligação profunda à terra.',

    'territorio.origem.eyebrow':    'Origem',
    'territorio.origem.title':      'Origem',
    'territorio.origem.short':      'A nossa origem está na terra. Um lugar, uma família, um sonho — cinco gerações ligadas ao Vale da Vilariça e ao Douro Superior.',
    'territorio.origem.long':       'Cinco gerações. Uma terra. Um vinho.\n\nHá histórias que começam numa adega. A nossa começou muito antes.\n\nHá cinco gerações que a família Meneses está ligada à vinha, à terra e ao ritmo das estações. No Douro Superior, no Vale da Vilariça, geração após geração aprendeu a cuidar da vinha, a respeitar o tempo e a compreender que aquilo que verdadeiramente permanece não se constrói de um dia para o outro.\n\nDurante décadas, plantámos vinha. Vindimámos. Cuidámos da terra. Passámos conhecimento de pais para filhos, mantendo viva uma ligação familiar que atravessou o tempo.\n\nMas faltava contar essa história numa garrafa. Foi dessa vontade que nasceu o Douro Nostrum.\n\nPela primeira vez, depois de cinco gerações ligadas à vinha, decidimos transformar as nossas uvas num vinho com o nosso nome, a nossa identidade e a nossa memória.\n\nNão quisemos simplesmente fazer vinho. Quisemos deixar um legado.\n\nCada garrafa Douro Nostrum representa aqueles que vieram antes de nós, o trabalho de quem hoje continua esta história e a responsabilidade de a transmitir às próximas gerações.\n\nÉ um vinho feito no Douro, mas nasceu sobretudo de uma família.\n\nCinco gerações a plantar vinha. Uma geração a transformar essa história em vinho.\n\nDouro Nostrum. A nossa terra. A nossa família. O nosso legado.',

    'territorio.readMore':          'Saber mais',

    /* ── Vinhos ── */
    'vinhos.eyebrow':       'Os nossos vinhos',
    'vinhos.title':         'Quatro famílias, uma tradição',
    'vinhos.lead':          'Descubra cada uma das categorias que produzimos. Cada família tem a sua personalidade, mas todas partilham o mesmo compromisso com a terra.',
    'vinhos.references':    'referências',
    'vinhos.viewInShop':    'Ver na loja →',
    'vinhos.desc.tintoColheita':  'Frutados e equilibrados, expressam a essência do ano de colheita.',
    'vinhos.desc.brancoColheita': 'Frescos e aromáticos, a alma dos nossos vales ensolarados.',
    'vinhos.desc.tintoReserva':   'Estágio prolongado em barrica, com taninos integrados e final longo.',
    'vinhos.desc.brancoReserva':  'Estrutura, complexidade e capacidade de envelhecimento.',

    /* ── VinhosOverlay ── */
    'overlay.eyebrow':         'Os nossos vinhos',
    'overlay.referenceSingular':'referência',
    'overlay.referencePlural': 'referências',
    'overlay.viewAll':         'Ver toda a colecção',
    'overlay.viewInShop':      'Ver na loja →',

    /* ── Loja ── */
    'loja.eyebrow':       'Loja',
    'loja.title':         'A nossa loja',
    'loja.lead':          'Descubra a nossa seleção de vinhos e escolha os que deseja receber em sua casa. Asseguramos entregas em todo o território nacional, com envio cuidado, seguro, rápido e a atenção que cada garrafa merece.',
    'loja.filterAll':     'Todos',
    'loja.empty':         'Nenhum vinho encontrado nesta categoria.',

    /* ── Vinhas ── */
    'vinhas.eyebrow':     'Terroir',
    'vinhas.title':       'As nossas vinhas',
    'vinhas.lead':        'No coração do Vale da Vilariça, no Douro Superior, as nossas parcelas reúnem castas autóctones tintas e brancas — cada uma com o seu carácter, todas com a marca do terroir.',
    'vinhas.mapPlaceholder': 'Mapa das parcelas — Vale da Vilariça, Torre de Moncorvo',
    'vinhas.parcelasEyebrow': 'As parcelas',
    'vinhas.parcelasTitle':   'Oito Castas - Um Vale',
    'vinhas.parcelaPrefix':   'Parcela',
    'vinhas.field.area':      'Área',
    'vinhas.field.altitude':  'Altitude',
    'vinhas.field.hectares':  'Hectares',
    'vinhas.field.castas':    'Castas',
    'vinhas.field.solo':      'Solo',
    'vinhas.photoPlaceholder':'Foto da parcela',
    'vinhas.quote':           '"Cada videira é um presente da natureza."',
    'vinhas.quoteAuthor':     '— Eng. Manuel Maria Meneses',

    /* 8 castas reais (altitude / ha) */
    'vinhas.casta.tn.nome': 'Touriga Nacional',
    'vinhas.casta.tn.desc': 'A casta mais emblemática do Douro, reconhecida pela sua elegância, intensidade aromática e extraordinária capacidade de envelhecimento.',
    'vinhas.casta.tn.alt':  '170 m',
    'vinhas.casta.tn.ha':   '8 ha',

    'vinhas.casta.tf.nome': 'Touriga Francesa',
    'vinhas.casta.tf.desc': 'Uma das grandes castas durienses, apreciada pela sua harmonia, riqueza aromática e contribuição para vinhos de grande equilíbrio.',
    'vinhas.casta.tf.alt':  '207 m',
    'vinhas.casta.tf.ha':   '12 ha',

    'vinhas.casta.tr.nome': 'Tinta Roriz',
    'vinhas.casta.tr.desc': 'Casta de estrutura e carácter, que origina vinhos firmes, intensos e com excelente aptidão para evolução em garrafa.',
    'vinhas.casta.tr.alt':  '197 m',
    'vinhas.casta.tr.ha':   '1 ha',

    'vinhas.casta.so.nome': 'Sousão',
    'vinhas.casta.so.desc': 'Conhecida pela sua cor profunda e frescura vibrante, dá origem a vinhos intensos, marcantes e de forte personalidade.',
    'vinhas.casta.so.alt':  '212 m',
    'vinhas.casta.so.ha':   '2 ha',

    'vinhas.casta.ta.nome': 'Tinta Amarela',
    'vinhas.casta.ta.desc': 'Distinta pela sua elegância e delicadeza, aporta frescura, complexidade aromática e um perfil subtilmente sofisticado.',
    'vinhas.casta.ta.alt':  '168 m',
    'vinhas.casta.ta.ha':   '4 ha',

    'vinhas.casta.rb.nome': 'Rabigato',
    'vinhas.casta.rb.desc': 'Casta de grande frescura e precisão, reconhecida pela sua acidez vibrante, mineralidade e capacidade de dar origem a brancos elegantes e distintos.',
    'vinhas.casta.rb.alt':  '113 m',
    'vinhas.casta.rb.ha':   '2 ha',

    'vinhas.casta.go.nome': 'Códega do Larinho',
    'vinhas.casta.go.desc': 'Casta de perfil delicado e aromático, marcada por notas florais, fruta branca e apontamentos cítricos. Confere aos vinhos volume, suavidade e elegância, contribuindo para brancos equilibrados e expressivos.',
    'vinhas.casta.go.alt':  '111 m',
    'vinhas.casta.go.ha':   '4 ha',

    'vinhas.casta.vi.nome': 'Viosinho',
    'vinhas.casta.vi.desc': 'Valorizada pela sua riqueza aromática e untuosidade natural, contribui para vinhos brancos de grande equilíbrio, complexidade e expressão.',
    'vinhas.casta.vi.alt':  '110 m',
    'vinhas.casta.vi.ha':   '4 ha',

    /* ── Sobre ── */
    'sobre.eyebrow':       'A nossa história',
    'sobre.title':         'Um sonho do pai,\nrealizado pelos filhos',
    'sobre.lead':          'No coração do Vale da Vilariça nasceu o Douro Nostrum — um vinho que continua o sonho do Eng. Manuel Maria Meneses, hoje levado adiante pelos seus filhos João e André.',

    'sobre.stat.foundation': 'Legado',
    'sobre.stat.generation': 'Herança',
    'sobre.stat.vineyard':   'Raízes',
    'sobre.stat.countries':  'Região',
    'sobre.stat.foundationVal': '5 Gerações',
    'sobre.stat.generationVal': 'Família Meneses',
    'sobre.stat.vineyardVal':   'Vale da Vilariça',
    'sobre.stat.countriesVal':  'Douro Superior',

    'sobre.missao.eyebrow': 'Filosofia',
    'sobre.missao.title':   'Tradição, autenticidade e paixão',
    'sobre.missao.p1':      'Nascido da vontade de dois irmãos, impulsionados pelo sonho do seu Pai, Douro Nostrum é mais do que um vinho. É uma celebração e uma homenagem ao trabalho árduo dos antepassados na região.',
    'sobre.missao.p2':      'Produzido com as melhores uvas, colhidas nas melhores parcelas do Vale da Vilariça, no Douro Superior, tudo é trabalhado ao pormenor — com tradição, autenticidade e paixão.',
    'sobre.missao.cta':     'Conhecer as vinhas',
    'sobre.missao.photoPlaceholder': 'Foto da vinha',

    'sobre.timeline.eyebrow': 'Marcos',
    'sobre.timeline.title':   'A nossa linha do tempo',
    'sobre.timeline.1923':    'Da herança de algumas parcelas de vinha nasce uma visão: reunir, preservar e dignificar o património da família. Durante três décadas, o Eng. Manuel Maria Meneses entrega a sua vida ao Douro, com especial dedicação ao Douro Superior, defendendo a região, os viticultores e as instituições durienses com convicção rara. Confrade fundador da Confraria dos Vinhos do Douro e participante ativo na afirmação do Douro como Património Mundial, deixa um legado de prestígio, dedicação e profundo amor à terra.',
    'sobre.timeline.1955':    'São identificadas e selecionadas as melhores parcelas, bem como as castas que melhor expressam a autenticidade do Vale da Vilariça.',
    'sobre.timeline.1982':    'A paixão pela vinha prolonga-se na geração seguinte. João e André crescem entre vinhas, memórias e ensinamentos, herdando uma tradição feita de respeito, exigência e ligação à terra.',
    'sobre.timeline.2005':    'Toma forma o propósito de honrar esse legado e de criar um vinho capaz de traduzir, com verdade e elevação, a grandeza do terroir.',
    'sobre.timeline.2018':    'Nasce o Douro Nostrum — um vinho de memória, identidade e homenagem, onde perdura a alma da família Meneses.',
    'sobre.timeline.hojeAno': '2023',
    'sobre.timeline.hoje':    'Continuamos a honrar a terra e a tradição, com a mesma exigência e paixão das gerações que nos precederam.',

    /* Anos para a coluna esquerda da timeline (substitui labels do ano) */
    'sobre.timeline.year.1923': '1986 — 2016',
    'sobre.timeline.year.1955': 'Ao longo deste caminho',
    'sobre.timeline.year.1982': 'Após 2016',
    'sobre.timeline.year.2005': '2020',
    'sobre.timeline.year.2018': '2023',

    'sobre.equipa.eyebrow': 'A Família',
    'sobre.equipa.title':   'A Família',
    'sobre.equipa.maria.cargo': 'Fundador (in memoriam)',
    'sobre.equipa.maria.bio':   'Engenheiro de espírito nobre e paixão intensa pela terra. Dedicou a vida à defesa do Douro e ao cultivo da vinha no Vale da Vilariça.',
    'sobre.equipa.joao.cargo':  'Sócio-gerente',
    'sobre.equipa.joao.bio':    'Filho de Manuel Maria. Herdou a paixão pela vinha e trouxe ao projeto a visão de transformar uma história de família num vinho com identidade.',
    'sobre.equipa.ana.cargo':   'Sócio-gerente',
    'sobre.equipa.ana.bio':     'Filho de Manuel Maria. Herdou uma profunda ligação à terra e assumiu a missão de preservar a essência da família, projetando-a em cada garrafa.',

    /* ── Contacto ── */
    'contacto.eyebrow':    'Contacto',
    'contacto.title':      'Fale connosco',
    'contacto.lead':       'Para encomendas especiais, parcerias ou simplesmente para partilhar o amor pelo vinho — estamos aqui.',
    'contacto.info.title':   'Informações',
    'contacto.info.phone':   'Telefone',
    'contacto.info.email':   'Email',
    'contacto.info.address': 'Morada',
    'contacto.mapPlaceholder': 'Mapa — Google Maps embed aqui',
    'contacto.form.title':   'Enviar mensagem',

    /* ── ContactForm ── */
    'form.name':         'Nome',
    'form.namePlaceholder': 'O seu nome',
    'form.email':        'Email',
    'form.emailPlaceholder': 'email@exemplo.pt',
    'form.subject':      'Assunto',
    'form.subjectPlaceholder': 'Sobre o que é a sua mensagem?',
    'form.message':      'Mensagem',
    'form.messagePlaceholder': 'Escreva aqui a sua mensagem…',
    'form.submit':       'Enviar mensagem',
    'form.sending':      'A enviar…',
    'form.errorName':    'Por favor indique o seu nome.',
    'form.errorEmailReq':'O email é obrigatório.',
    'form.errorEmailInvalid': 'Email inválido.',
    'form.errorMsg':     'Escreva a sua mensagem.',
    'form.errorGeneric': 'Não foi possível enviar a mensagem. Tente novamente.',
    'form.errorRateLimited': 'Demasiados pedidos. Tente novamente dentro de {seconds} segundos.',
    'form.sentLabel':    'Mensagem enviada',
    'form.sentBody':     'Obrigado pelo contacto.\nResponderemos em breve.',
    'form.sentNew':      'Nova mensagem',

    /* ── Carrinho ── */
    'cart.eyebrow':         'Carrinho',
    'cart.emptyTitle':      'O seu carrinho está vazio',
    'cart.emptyLead':       'Ainda não adicionou nenhum vinho. Explore a nossa colecção e encontre o companheiro perfeito para a próxima celebração.',
    'cart.emptyCta':        'Ir para a loja',
    'cart.title':           'O seu carrinho',
    'cart.itemSingular':    'artigo',
    'cart.itemPlural':      'artigos',
    'cart.unit':            '/ unidade',
    'cart.qtyDecrease':     'Diminuir quantidade',
    'cart.qtyIncrease':     'Aumentar quantidade',
    'cart.remove':          'Remover',
    'cart.continueShopping':'← Continuar a comprar',
    'cart.clear':           'Esvaziar carrinho',
    'cart.summary':         'Resumo do pedido',
    'cart.comfortMessage':  'Preparado e embalado com carinho no Douro e enviado em 1 a 4 dias úteis, para chegar até si em perfeitas condições!',
    'cart.subtotal':        'Subtotal',
    'cart.shipping':        'Envio',
    'cart.shippingFree':    'Grátis',
    'cart.shippingAtCheckout':     'Calculado no checkout',
    'cart.minQty.warning':  'As encomendas saem em caixas fechadas de 6 garrafas. Adicione mais {count} garrafa(s) (qualquer combinação) para poder finalizar a compra.',
    'cart.total':           'Total',
    'cart.checkout':        'Finalizar compra',
    'cart.taxesNote':       'Impostos incluídos. Envio calculado no checkout.',

    /* ── Checkout: código de desconto ── */
    'checkout.discount.label':    'Código de desconto',
    'checkout.discount.placeholder': 'Ex.: VERAO10',
    'checkout.discount.apply':    'Aplicar',
    'checkout.discount.checking': 'A verificar…',
    'checkout.discount.applied':  'Desconto',
    'checkout.discount.remove':   'Remover',
    'checkout.discount.invalid':  'Código inválido ou expirado.',
    'checkout.discount.noLongerValid': 'O código de desconto deixou de ser válido. Remova-o para continuar.',

    /* ── Checkout ── */
    'checkout.eyebrow':       'Checkout',
    'checkout.title':         'Finalizar compra',
    'checkout.contact':       'Contacto',
    'checkout.address':       'Morada de entrega',
    'checkout.payment':       'Pagamento',
    'checkout.notes':         'Notas (opcional)',
    'checkout.terms':         'Aceito os termos e condições e a política de privacidade.',
    'checkout.summary':       'Resumo',
    'checkout.payButton':     'Pagar {amount}',
    'checkout.processing':    'A processar…',
    'checkout.backToCart':    '← Voltar ao carrinho',

    'checkout.field.name':       'Nome',
    'checkout.field.surname':    'Apelido',
    'checkout.field.email':      'Email',
    'checkout.field.phone':      'Telefone',
    'checkout.field.address':    'Morada',
    'checkout.field.addressPh':  'Rua, número, andar',
    'checkout.field.city':       'Cidade',
    'checkout.field.postal':     'Código postal',
    'checkout.field.country':    'País',
    'checkout.field.nif':        'NIF (opcional)',
    'checkout.field.nifPh':      'Para faturação com contribuinte',
    'checkout.field.notesPh':    'Instruções de entrega, mensagens, etc.',

    'checkout.method.card':       'Cartão de crédito',
    'checkout.method.mbway':      'MB WAY',
    'checkout.method.multibanco': 'Multibanco',
    'checkout.method.cardNote':   'Após confirmar a encomenda, será redirecionado para uma página segura para introduzir os dados do cartão.',
    'checkout.method.mbwayNote':  'Receberá uma notificação na sua app MB WAY após submeter o pedido.',
    'checkout.method.multibancoNote': 'Receberá uma entidade e referência Multibanco para pagar num ATM ou homebanking.',

    'checkout.country.pt': 'Portugal',
    'checkout.country.es': 'Espanha',
    'checkout.country.fr': 'França',
    'checkout.country.uk': 'Reino Unido',
    'checkout.country.de': 'Alemanha',
    'checkout.country.other': 'Outro',

    'checkout.success.eyebrow': 'Encomenda confirmada',
    'checkout.success.title':   'Obrigado, {name}!',
    'checkout.success.lead':    'Recebemos a sua encomenda no valor de {amount}. Enviámos os detalhes para {email}.',
    'checkout.success.cta1':    'Voltar ao início',
    'checkout.success.cta2':    'Continuar a comprar',
    'checkout.empty.title':     'Não há nada para finalizar',
    'checkout.empty.lead':      'Adicione vinhos ao seu carrinho antes de proceder ao checkout.',

    'checkout.minQty.title':    'Falta completar a caixa',
    'checkout.minQty.lead':     'As nossas encomendas saem em caixas fechadas de 6 garrafas (pode ser qualquer combinação de vinhos). Adicione mais {count} garrafa(s) para poder finalizar a compra.',
    'checkout.minQty.cta':      'Voltar ao carrinho',

    'checkout.err.name':         'Indique o seu nome',
    'checkout.err.surname':      'Indique o apelido',
    'checkout.err.email':        'Email inválido',
    'checkout.err.phone':        'Telefone inválido',
    'checkout.err.address':      'Indique a morada',
    'checkout.err.city':         'Indique a cidade',
    'checkout.err.postal':       'Formato: 0000-000',
    'checkout.err.nif':          'NIF inválido',
    'checkout.err.terms':        'Deve aceitar os termos',
    'checkout.err.generic':      'Não foi possível concluir a encomenda. Tente novamente.',

    'checkout.payment.initiationFailed':       'A sua encomenda foi guardada, mas não foi possível iniciar o pagamento. Entraremos em contacto para concluir o processo.',
    'checkout.payment.notRequired':            'O código de desconto cobriu o valor total da encomenda — não é necessário nenhum pagamento.',
    'checkout.payment.mbwayWaiting':           'Confirme o pagamento na sua app MB WAY para concluir a encomenda.',
    'checkout.payment.multibancoInstructions': 'Use os dados abaixo para pagar num ATM ou homebanking.',
    'checkout.payment.entity':    'Entidade',
    'checkout.payment.reference': 'Referência',
    'checkout.payment.amount':    'Valor',

    /* ── Resultado do pagamento por cartão (regresso do ifthenpay) ── */
    'checkoutResult.success.title':   'Pagamento confirmado',
    'checkoutResult.success.lead':    'Obrigado! O pagamento foi confirmado e a sua encomenda está a ser preparada.',
    'checkoutResult.error.title':     'Não foi possível concluir o pagamento',
    'checkoutResult.error.lead':      'Ocorreu um erro ao processar o pagamento. A sua encomenda ficou guardada — pode tentar novamente ou contactar-nos.',
    'checkoutResult.cancelled.title': 'Pagamento cancelado',
    'checkoutResult.cancelled.lead':  'O pagamento foi cancelado. A sua encomenda ficou guardada, pode concluir o pagamento mais tarde ou contactar-nos.',
    'checkoutResult.cta1':            'Voltar ao início',
    'checkoutResult.cta2':            'Continuar a comprar',

    /* ── WineCard ── */
    'card.add':           'Adicionar',
    'card.buy':           'Comprar',
    'card.imagePlaceholder': 'Imagem',
    'card.addAria':       'Adicionar {name} ao carrinho',
    'card.buyAria':       'Comprar {name}',

    /* ── Estados genéricos ── */
    'common.loading': 'A carregar…',
    'common.error':   'Não foi possível carregar a informação. Tente novamente mais tarde.',
    'common.retry':   'Tentar novamente',
  },

  en: {
    /* ── Wine types ── */
    'wine.type.tintoColheita':  'Red Vintage',
    'wine.type.brancoColheita': 'White Vintage',
    'wine.type.tintoReserva':   'Red Reserve',
    'wine.type.brancoReserva':  'White Reserve',

    /* ── Badges ── */
    'badge.destaque': 'Featured',
    'badge.limitado': 'Limited',
    'badge.novidade': 'New',

    /* ── Navbar ── */
    'nav.home':       'Home',
    'nav.vinhos':     'Wines',
    'nav.loja':       'Shop',
    'nav.vinhas':     'Vineyards',
    'nav.sobre':      'About',
    'nav.contacto':   'Contact',
    'nav.cart.aria':  'Cart with {n} {n_word}',
    'nav.cart.itemSingular': 'item',
    'nav.cart.itemPlural':   'items',
    'nav.menuOpen':   'Open menu',
    'nav.menuClose':  'Close menu',
    'nav.cartLabel':  'Cart',

    /* ── Footer ── */
    'footer.nav':              'Navigate',
    'footer.contact':          'Contact',
    'footer.follow':           'Follow us',
    'footer.shop':             'Shop',
    'footer.shop.cta':         'Buy',
    'footer.copyright':        'All rights reserved',

    'footer.tagline':          'DOC DOURO\nDOURO SUPERIOR',
    'footer.brandLine':        'Casa Agrícola Meneses',
    'footer.address':          'Rua Vasco da Gama 43\n5160-297 Torre de Moncorvo · Portugal',

    'footer.newsletter.title':       'Newsletter',
    'footer.newsletter.lead':        'Get new releases, news and invitations to estate visits.',
    'footer.newsletter.placeholder': 'Your email',
    'footer.newsletter.cta':         'Subscribe',
    'footer.newsletter.success':     'Thank you! You are subscribed.',
    'footer.newsletter.invalid':     'Please enter a valid email.',

    'footer.legal.privacy':    'Privacy Policy',
    'footer.legal.terms':      'Terms & Conditions',
    'footer.legal.cookies':    'Cookies',

    'footer.social.facebook':  'Facebook',
    'footer.social.instagram': 'Instagram',

    /* ── Home ── */
    'home.hero.eyebrow':   'Vilariça Valley · Douro Superior',
    /* Narrative arc: land → dream → continuation → wine */
    'home.hero.title':         'Where the mountains embrace the horizon',
    'home.hero.title.familia': 'A Father\u2019s dream',
    'home.hero.title.quinta':  'The will of two sons',
    'home.hero.title.vinho':   "Every drop carries the Douro and the family’s soul",
    'home.hero.photoPlaceholder': 'Vertical photo',
    'home.hero.cta1':      'Buy',
    'home.hero.cta2':      'Our story',

    'home.stats.since':       'Origin',
    'home.stats.hectares':    'Valley',
    'home.stats.wines':       'Sub-region',
    'home.stats.sinceValue':  '2023',
    'home.stats.hectaresValue': 'Vilariça',
    'home.stats.winesValue':  'Douro Superior',

    'home.featured.eyebrow': 'Selection',
    'home.featured.title':   'Featured wines',
    'home.featured.lead':    'A curated selection of our finest, ready to discover.',
    'home.featured.cta':     'View the full collection',

    'home.about.eyebrow': 'About us',
    'home.about.title':   'Tradition and excellence in every bottle',
    'home.about.lead':    'Born of the will of two brothers, driven by their Father\u2019s dream, Douro Nostrum is more than a wine. It is a celebration and a tribute to the hard work of their ancestors in the region, and an expression of the pride for the origins that guides every step.',
    'home.about.cta':     'Learn more',

    /* ── Age gate ── */
    'age.title':   'Welcome',
    'age.brand':   'Douro Nostrum',
    'age.lead':    'To enter the site, please confirm that you are of legal drinking age.',
    'age.confirm': 'I am over 18',
    'age.deny':    'I am under 18',
    'age.denied':  'We are sorry, but access to this site is restricted to those aged 18 and over.',

    'home.cta.eyebrow':   'Contact',
    'home.cta.title':     'Have a question?',
    'home.cta.lead':      'We are always available to answer your questions or simply to talk about wine.',
    'home.cta.button':    'Get in touch',

    /* ── Pages: Douro Superior / Vilariça / Origin ── */
    'territorio.douroSup.eyebrow':  'Sub-region',
    'territorio.douroSup.title':    'Douro Superior',
    'territorio.douroSup.short':    'In the Douro Superior, the strength of nature meets the nobility of time. Among striking landscapes, an extreme climate and singular soils, an intense, elegant and deeply authentic wine expression is born.\n\nIt is a land of resilience and excellence, where every vine translates the soul of the Douro into wines of unmistakable identity, natural sophistication and rare depth.',
    'territorio.douroSup.long':     'The Douro Superior represents the most intense, authentic and majestic expression of the Douro Demarcated Region. Located in the easternmost area of this historic wine region, this sub-region is distinguished by its imposing landscape, by exceptional natural conditions and by a wine identity of rare depth.\n\nMarked by a hot, dry and demanding climate, with intense summers and scarce rainfall, the Douro Superior challenges the vine to surpass itself in every cycle. From this relationship between natural rigour and resilience comes an excellent raw material: grapes of extraordinary concentration, aromatic richness and remarkable balance. The predominantly schistous soils, combined with the strength of the light, the thermal amplitude and the singularity of the terroir, give the wines a distinct structure, natural elegance and an impressive ability to evolve in bottle.\n\nIt is in this unique landscape that wines of high signature are born, where intensity is harmonised with sophistication. The reds reveal depth, texture and complexity, with notes of ripe black fruit, spices and a remarkable presence in the glass. The whites, produced mostly at higher altitudes, surprise with their freshness, precision and minerality. Port Wines also find in the Douro Superior an expression of great nobility, marked by concentration, richness and longevity.\n\nMore than a sub-region, the Douro Superior is today a symbol of excellence, vision and authenticity. A territory where tradition and innovation coexist in perfect harmony, giving rise to wines of singular character — capable of translating, with distinction, the greatness of the Douro and the prestige of Portuguese viticulture.',

    'territorio.vilarica.eyebrow':  'Vineyards',
    'territorio.vilarica.title':    'Vilariça Valley',
    'territorio.vilarica.short':    'In the heart of northeast Portugal, the Vilariça Valley reveals itself as a territory of rare generosity and timeless beauty. Shaped by fertile soils, by the intense light of the Douro Superior and by a deep bond to the land, this valley gives rise to products of excellence, where authenticity, elegance and character come together in a unique way.\n\nBetween agricultural tradition, the richness of the landscape and the nobility of a unique terroir, the Vilariça Valley stands out as a symbol of identity, sophistication and natural excellence.',
    'territorio.vilarica.long':     'The Vilariça Valley is one of the most remarkable agricultural territories in the northeast of Portugal, distinguished by the fertility of its soils, the richness of its landscape and the authenticity it gives to everything that is born there. Situated in the municipality of Torre de Moncorvo, between the Reboredo and Lousa mountains, this valley enjoys exceptional natural conditions, which make it particularly suited to high-quality agricultural production.\n\nWith a Mediterranean climate, hot and bright summers and harsh winters, the valley brings together unique features for the development of valuable crops. Wines, olive oils, almonds and fruit find here a privileged terroir, where the generosity of the land is allied with tradition and the know-how of several generations.\n\nIncluded in the area of influence of the Douro Superior and in close connection with the historic Douro Demarcated Region, the Vilariça Valley shares the nobility of one of the world’s most prestigious wine territories. In this region of strong identity, the soils, the climate and the landscape shape products of singular character — among which wines of great expression, elegance and authenticity stand out.\n\nMore than a fertile valley, Vilariça is a territory of excellence, where nature, history and agricultural vocation live together in perfect harmony. Its serene beauty, heritage and the exceptional quality of its production make this place an essential reference for those seeking genuineness and a deep connection to the land.',

    'territorio.origem.eyebrow':    'Origin',
    'territorio.origem.title':      'Origin',
    'territorio.origem.short':      'Our origin is in the land. A place, a family, a dream — five generations bound to the Vilariça Valley and to the Douro Superior.',
    'territorio.origem.long':       'Five generations. One land. One wine.\n\nSome stories begin in a cellar. Ours began long before.\n\nFor five generations, the Meneses family has been tied to the vine, to the land and to the rhythm of the seasons. In the Douro Superior, in the Vilariça Valley, generation after generation learned to care for the vine, to respect time, and to understand that what truly endures cannot be built overnight.\n\nFor decades, we planted vines. We harvested. We cared for the land. We passed knowledge from parents to children, keeping alive a family bond that endured through time.\n\nBut that story was still missing from a bottle. It was from that desire that Douro Nostrum was born.\n\nFor the first time, after five generations tied to the vine, we decided to turn our grapes into a wine bearing our name, our identity and our memory.\n\nWe did not simply want to make wine. We wanted to leave a legacy.\n\nEvery bottle of Douro Nostrum represents those who came before us, the work of those who continue this story today, and the responsibility of passing it on to the next generations.\n\nIt is a wine made in the Douro, but born above all from a family.\n\nFive generations planting vines. One generation turning that story into wine.\n\nDouro Nostrum. Our land. Our family. Our legacy.',

    'territorio.readMore':          'Read more',

    /* ── Wines ── */
    'vinhos.eyebrow':       'Our wines',
    'vinhos.title':         'Four families, one tradition',
    'vinhos.lead':          'Discover each of the categories we produce. Every family has its own personality, but all share the same commitment to the land.',
    'vinhos.references':    'references',
    'vinhos.viewInShop':    'View in shop →',
    'vinhos.desc.tintoColheita':  'Fruity and balanced, expressing the essence of the vintage year.',
    'vinhos.desc.brancoColheita': 'Fresh and aromatic — the soul of our sun-drenched valleys.',
    'vinhos.desc.tintoReserva':   'Long barrel ageing, integrated tannins and a lingering finish.',
    'vinhos.desc.brancoReserva':  'Structure, complexity and ageing potential.',

    /* ── VinhosOverlay ── */
    'overlay.eyebrow':         'Our wines',
    'overlay.referenceSingular':'reference',
    'overlay.referencePlural': 'references',
    'overlay.viewAll':         'View the full collection',
    'overlay.viewInShop':      'View in shop →',

    /* ── Shop ── */
    'loja.eyebrow':       'Shop',
    'loja.title':         'Our shop',
    'loja.lead':          'Discover our wine selection and choose the ones you’d like delivered to your home. We ship anywhere in the country with careful, secure and timely delivery, giving every bottle the attention it deserves.',
    'loja.filterAll':     'All',
    'loja.empty':         'No wines found in this category.',

    /* ── Vineyards ── */
    'vinhas.eyebrow':     'Terroir',
    'vinhas.title':       'Our vineyards',
    'vinhas.lead':        'In the heart of the Vilariça Valley, in the Douro Superior, our plots gather native red and white varieties — each with its own character, all bearing the mark of the terroir.',
    'vinhas.mapPlaceholder': 'Plot map — Vilariça Valley, Torre de Moncorvo',
    'vinhas.parcelasEyebrow': 'The plots',
    'vinhas.parcelasTitle':   'The Vilariça Valley in three expressions',
    'vinhas.parcelaPrefix':   'Plot',
    'vinhas.field.area':      'Area',
    'vinhas.field.altitude':  'Altitude',
    'vinhas.field.hectares':  'Hectares',
    'vinhas.field.castas':    'Grapes',
    'vinhas.field.solo':      'Soil',
    'vinhas.photoPlaceholder':'Plot photo',
    'vinhas.quote':           '"Every vine is a gift of nature."',
    'vinhas.quoteAuthor':     '— Eng. Manuel Maria Meneses',

    /* 8 real grape varieties (altitude / hectares) */
    'vinhas.casta.tn.nome': 'Touriga Nacional',
    'vinhas.casta.tn.desc': 'The Douro’s flagship grape, renowned for its elegance, aromatic intensity and outstanding ageing potential.',
    'vinhas.casta.tn.alt':  '170 m',
    'vinhas.casta.tn.ha':   '8 ha',

    'vinhas.casta.tf.nome': 'Touriga Francesa',
    'vinhas.casta.tf.desc': 'One of the great Douro varieties, prized for its balance, aromatic depth and contribution to wines of remarkable harmony.',
    'vinhas.casta.tf.alt':  '207 m',
    'vinhas.casta.tf.ha':   '12 ha',

    'vinhas.casta.tr.nome': 'Tinta Roriz',
    'vinhas.casta.tr.desc': 'A variety of structure and character, producing firm, intense wines with great potential for ageing in bottle.',
    'vinhas.casta.tr.alt':  '197 m',
    'vinhas.casta.tr.ha':   '1 ha',

    'vinhas.casta.so.nome': 'Sousão',
    'vinhas.casta.so.desc': 'Known for its deep colour and vibrant freshness, it yields intense, characterful wines with a strong personality.',
    'vinhas.casta.so.alt':  '212 m',
    'vinhas.casta.so.ha':   '2 ha',

    'vinhas.casta.ta.nome': 'Tinta Amarela',
    'vinhas.casta.ta.desc': 'Distinguished by its elegance and delicacy, it brings freshness, aromatic complexity and a subtly sophisticated profile.',
    'vinhas.casta.ta.alt':  '168 m',
    'vinhas.casta.ta.ha':   '4 ha',

    'vinhas.casta.rb.nome': 'Rabigato',
    'vinhas.casta.rb.desc': 'A variety of great freshness and precision, recognised for its vibrant acidity, minerality and its capacity to produce elegant, distinctive whites.',
    'vinhas.casta.rb.alt':  '113 m',
    'vinhas.casta.rb.ha':   '2 ha',

    'vinhas.casta.go.nome': 'Códega do Larinho',
    'vinhas.casta.go.desc': 'A delicate, aromatic variety, marked by floral notes, white fruit and hints of citrus. It lends the wines body, smoothness and elegance, contributing to balanced, expressive white wines.',
    'vinhas.casta.go.alt':  '111 m',
    'vinhas.casta.go.ha':   '4 ha',

    'vinhas.casta.vi.nome': 'Viosinho',
    'vinhas.casta.vi.desc': 'Valued for its aromatic richness and natural unctuosity, it contributes to white wines of great balance, complexity and expression.',
    'vinhas.casta.vi.alt':  '110 m',
    'vinhas.casta.vi.ha':   '4 ha',

    /* ── About ── */
    'sobre.eyebrow':       'Our story',
    'sobre.title':         'A father’s dream,\nrealised by his sons',
    'sobre.lead':          'Born in the heart of the Vilariça Valley, Douro Nostrum carries on the dream of Eng. Manuel Maria Meneses — today taken forward by his sons João and André.',

    'sobre.stat.foundation': 'Legacy',
    'sobre.stat.generation': 'Heritage',
    'sobre.stat.vineyard':   'Roots',
    'sobre.stat.countries':  'Region',
    'sobre.stat.foundationVal': '5 Generations',
    'sobre.stat.generationVal': 'Meneses Family',
    'sobre.stat.vineyardVal':   'Vilariça Valley',
    'sobre.stat.countriesVal':  'Douro Superior',

    'sobre.missao.eyebrow': 'Philosophy',
    'sobre.missao.title':   'Tradition, authenticity and passion',
    'sobre.missao.p1':      'Born of the will of two brothers, driven by their Father\u2019s dream, Douro Nostrum is more than a wine. It is a celebration and a tribute to the hard work of their ancestors in the region.',
    'sobre.missao.p2':      'Made with the finest grapes, harvested from the best plots of the Vilariça Valley in the Douro Superior, every detail is crafted with tradition, authenticity and passion.',
    'sobre.missao.cta':     'Discover the vineyards',
    'sobre.missao.photoPlaceholder': 'Vineyard photo',

    'sobre.timeline.eyebrow': 'Milestones',
    'sobre.timeline.title':   'Our timeline',
    'sobre.timeline.1923':    'A vision is born from a few inherited plots of vineyard: to gather, preserve and dignify the family heritage. For three decades, Eng. Manuel Maria Meneses devotes his life to the Douro, with special dedication to the Douro Superior, defending the region, its growers and its institutions with rare conviction. Founding member of the Confraria dos Vinhos do Douro and active in the recognition of the Douro as a UNESCO World Heritage Site, he leaves a legacy of prestige, dedication and deep love for the land.',
    'sobre.timeline.1955':    'The best plots are identified, alongside the grape varieties that best express the authenticity of the Vilariça Valley.',
    'sobre.timeline.1982':    'The passion for the vineyard continues with the next generation. João and André grow up among the vines, inheriting a tradition built on respect, demand and connection to the land.',
    'sobre.timeline.2005':    'A purpose takes shape: to honour the legacy and create a wine able to express, with truth and elevation, the greatness of the terroir.',
    'sobre.timeline.2018':    'Douro Nostrum is born — a wine of memory, identity and tribute, where the soul of the Meneses family endures.',
    'sobre.timeline.hojeAno': '2023',
    'sobre.timeline.hoje':    'We continue to honour the land and the tradition, with the same demand and passion of the generations that came before us.',

    /* Year labels for the left column of the timeline */
    'sobre.timeline.year.1923': '1986 — 2016',
    'sobre.timeline.year.1955': 'Along the way',
    'sobre.timeline.year.1982': 'After 2016',
    'sobre.timeline.year.2005': '2020',
    'sobre.timeline.year.2018': '2023',

    'sobre.equipa.eyebrow': 'The family',
    'sobre.equipa.title':   'The family',
    'sobre.equipa.maria.cargo': 'Founder (in memoriam)',
    'sobre.equipa.maria.bio':   'An engineer of noble spirit and intense passion for the land. He devoted his life to the Douro and to growing vines in the Vilariça Valley.',
    'sobre.equipa.joao.cargo':  'Managing partner',
    'sobre.equipa.joao.bio':    'Son of Manuel Maria. He inherited a passion for the vine and brought to the project the vision of turning a family story into a wine with its own identity.',
    'sobre.equipa.ana.cargo':   'Managing partner',
    'sobre.equipa.ana.bio':     'Son of Manuel Maria. He inherited a deep connection to the land and took on the mission of preserving the family’s essence, projecting it into every bottle.',

    /* ── Contact ── */
    'contacto.eyebrow':    'Contact',
    'contacto.title':      'Get in touch',
    'contacto.lead':       'For special orders, partnerships, or simply to share the love of wine — we are here.',
    'contacto.info.title':   'Information',
    'contacto.info.phone':   'Phone',
    'contacto.info.email':   'Email',
    'contacto.info.address': 'Address',
    'contacto.mapPlaceholder': 'Map — Google Maps embed here',
    'contacto.form.title':   'Send a message',

    /* ── ContactForm ── */
    'form.name':         'Name',
    'form.namePlaceholder': 'Your name',
    'form.email':        'Email',
    'form.emailPlaceholder': 'email@example.com',
    'form.subject':      'Subject',
    'form.subjectPlaceholder': 'What is your message about?',
    'form.message':      'Message',
    'form.messagePlaceholder': 'Write your message here…',
    'form.submit':       'Send message',
    'form.sending':      'Sending…',
    'form.errorName':    'Please provide your name.',
    'form.errorEmailReq':'Email is required.',
    'form.errorEmailInvalid': 'Invalid email.',
    'form.errorMsg':     'Please write your message.',
    'form.errorGeneric': 'Could not send the message. Please try again.',
    'form.errorRateLimited': 'Too many requests. Please try again in {seconds} seconds.',
    'form.sentLabel':    'Message sent',
    'form.sentBody':     'Thank you for getting in touch.\nWe will reply shortly.',
    'form.sentNew':      'New message',

    /* ── Cart ── */
    'cart.eyebrow':         'Cart',
    'cart.emptyTitle':      'Your cart is empty',
    'cart.emptyLead':       'You have not added any wines yet. Explore our collection and find the perfect companion for your next celebration.',
    'cart.emptyCta':        'Go to shop',
    'cart.title':           'Your cart',
    'cart.itemSingular':    'item',
    'cart.itemPlural':      'items',
    'cart.unit':            '/ unit',
    'cart.qtyDecrease':     'Decrease quantity',
    'cart.qtyIncrease':     'Increase quantity',
    'cart.remove':          'Remove',
    'cart.continueShopping':'← Continue shopping',
    'cart.clear':           'Empty cart',
    'cart.summary':         'Order summary',
    'cart.comfortMessage':  'Carefully prepared and packed in the Douro, and shipped within 1 to 4 business days, to arrive at your door in perfect condition!',
    'cart.subtotal':        'Subtotal',
    'cart.shipping':        'Shipping',
    'cart.shippingFree':    'Free',
    'cart.shippingAtCheckout':     'Calculated at checkout',
    'cart.minQty.warning':  'Orders ship in sealed cases of 6 bottles. Add {count} more bottle(s) (any mix) to proceed to checkout.',
    'cart.total':           'Total',
    'cart.checkout':        'Checkout',
    'cart.taxesNote':       'Taxes included. Shipping calculated at checkout.',

    /* ── Checkout: discount code ── */
    'checkout.discount.label':    'Discount code',
    'checkout.discount.placeholder': 'e.g.: SUMMER10',
    'checkout.discount.apply':    'Apply',
    'checkout.discount.checking': 'Checking…',
    'checkout.discount.applied':  'Discount',
    'checkout.discount.remove':   'Remove',
    'checkout.discount.invalid':  'Invalid or expired code.',
    'checkout.discount.noLongerValid': 'The discount code is no longer valid. Remove it to continue.',

    /* ── Checkout ── */
    'checkout.eyebrow':       'Checkout',
    'checkout.title':         'Complete purchase',
    'checkout.contact':       'Contact',
    'checkout.address':       'Delivery address',
    'checkout.payment':       'Payment',
    'checkout.notes':         'Notes (optional)',
    'checkout.terms':         'I accept the terms and conditions and the privacy policy.',
    'checkout.summary':       'Summary',
    'checkout.payButton':     'Pay {amount}',
    'checkout.processing':    'Processing…',
    'checkout.backToCart':    '← Back to cart',

    'checkout.field.name':       'First name',
    'checkout.field.surname':    'Last name',
    'checkout.field.email':      'Email',
    'checkout.field.phone':      'Phone',
    'checkout.field.address':    'Address',
    'checkout.field.addressPh':  'Street, number, floor',
    'checkout.field.city':       'City',
    'checkout.field.postal':     'Postal code',
    'checkout.field.country':    'Country',
    'checkout.field.nif':        'Tax number (optional)',
    'checkout.field.nifPh':      'For invoicing with tax number',
    'checkout.field.notesPh':    'Delivery instructions, messages, etc.',

    'checkout.method.card':       'Credit card',
    'checkout.method.mbway':      'MB WAY',
    'checkout.method.multibanco': 'Multibanco',
    'checkout.method.cardNote':   'After confirming the order, you will be redirected to a secure page to enter your card details.',
    'checkout.method.mbwayNote':  'You will receive a notification in your MB WAY app after submitting the order.',
    'checkout.method.multibancoNote': 'You will receive a Multibanco entity and reference to pay at an ATM or homebanking.',

    'checkout.country.pt': 'Portugal',
    'checkout.country.es': 'Spain',
    'checkout.country.fr': 'France',
    'checkout.country.uk': 'United Kingdom',
    'checkout.country.de': 'Germany',
    'checkout.country.other': 'Other',

    'checkout.success.eyebrow': 'Order confirmed',
    'checkout.success.title':   'Thank you, {name}!',
    'checkout.success.lead':    'We have received your order for {amount}. Details have been sent to {email}.',
    'checkout.success.cta1':    'Back to home',
    'checkout.success.cta2':    'Continue shopping',
    'checkout.empty.title':     'Nothing to finalize',
    'checkout.empty.lead':      'Add wines to your cart before proceeding to checkout.',

    'checkout.minQty.title':    'Complete the case first',
    'checkout.minQty.lead':     'Our orders ship in sealed cases of 6 bottles (any mix of wines). Add {count} more bottle(s) to proceed to checkout.',
    'checkout.minQty.cta':      'Back to cart',

    'checkout.err.name':         'Please provide your first name',
    'checkout.err.surname':      'Please provide your last name',
    'checkout.err.email':        'Invalid email',
    'checkout.err.phone':        'Invalid phone',
    'checkout.err.address':      'Please provide an address',
    'checkout.err.city':         'Please provide a city',
    'checkout.err.postal':       'Format: 0000-000',
    'checkout.err.nif':          'Invalid tax number',
    'checkout.err.terms':        'You must accept the terms',
    'checkout.err.generic':      'Could not complete the order. Please try again.',

    'checkout.payment.initiationFailed':       'Your order has been saved, but we could not start the payment. We will contact you to complete the process.',
    'checkout.payment.notRequired':            'The discount code covered the full order total — no payment is required.',
    'checkout.payment.mbwayWaiting':           'Confirm the payment in your MB WAY app to complete the order.',
    'checkout.payment.multibancoInstructions': 'Use the details below to pay at an ATM or homebanking.',
    'checkout.payment.entity':    'Entity',
    'checkout.payment.reference': 'Reference',
    'checkout.payment.amount':    'Amount',

    /* ── Card payment result (return from ifthenpay) ── */
    'checkoutResult.success.title':   'Payment confirmed',
    'checkoutResult.success.lead':    'Thank you! Your payment was confirmed and your order is being prepared.',
    'checkoutResult.error.title':     'We could not complete the payment',
    'checkoutResult.error.lead':      'An error occurred while processing the payment. Your order has been saved — you can try again or contact us.',
    'checkoutResult.cancelled.title': 'Payment cancelled',
    'checkoutResult.cancelled.lead':  'The payment was cancelled. Your order has been saved — you can complete the payment later or contact us.',
    'checkoutResult.cta1':            'Back to home',
    'checkoutResult.cta2':            'Continue shopping',

    /* ── WineCard ── */
    'card.add':           'Add',
    'card.buy':           'Buy',
    'card.imagePlaceholder': 'Image',
    'card.addAria':       'Add {name} to cart',
    'card.buyAria':       'Buy {name}',

    /* ── Generic states ── */
    'common.loading': 'Loading…',
    'common.error':   'Could not load the information. Please try again later.',
    'common.retry':   'Try again',
  },
};

/* ============================================================
   Mapeamento de tipo de vinho → chave de tradução
   ============================================================ */
export const TYPE_KEYS = {
  'Tinto Colheita':  'wine.type.tintoColheita',
  'Branco Colheita': 'wine.type.brancoColheita',
  'Tinto Reserva':   'wine.type.tintoReserva',
  'Branco Reserva':  'wine.type.brancoReserva',
};

/* ============================================================
   Mapeamento de descrição por tipo (Vinhos / Overlay)
   ============================================================ */
export const TYPE_DESC_KEYS = {
  'Tinto Colheita':  'vinhos.desc.tintoColheita',
  'Branco Colheita': 'vinhos.desc.brancoColheita',
  'Tinto Reserva':   'vinhos.desc.tintoReserva',
  'Branco Reserva':  'vinhos.desc.brancoReserva',
};

/* ============================================================
   Mapeamento de badge → chave
   ============================================================ */
export const BADGE_KEYS = {
  'Destaque': 'badge.destaque',
  'Limitado': 'badge.limitado',
  'Novidade': 'badge.novidade',
};

export default dict;
